import { isHK } from '@didi/webx-js'
import { HKDomainConvert } from '../../js/hk_url'
import { request } from '../api/request'
import { GlobalEnv } from '../global_env'

const url = HKDomainConvert(
  'https://winter-campaign.xiaojukeji.com/strategy-genrec/biztech_arch/strategygenrec/event',
  isHK
)

/**
 * 上报算法埋点
 * @param {Object} eventParams - 事件参数
 */
export const sendRecOrderRequest = async eventParams => {
  try {
    if (GlobalEnv.loginInfo.token) {
      request.get(url, eventParams)
    }
  } catch (error) {}
}
